import type { NavigationLink } from "@hooks/useNavigationLinks"

import type { NavSidebarItemProps } from "@organisms/NavSidebar/components/NavSidebarItem/NavSidebarItem.types"

export default function filterUserLinks<LinkType extends NavSidebarItemProps | NavigationLink>(
    links: LinkType[] | undefined,
    user: User | null,
): LinkType[] {
    return (links ?? []).filter((link) => !link.predicate || (user ? link.predicate(user) : false))
}
